var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 9.34692H21.5156V4.84692",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.336 17.8313C17.1825 18.9857 15.7125 19.7721 14.112 20.091C12.5114 20.4099 10.8523 20.2469 9.34442 19.6227C7.83653 18.9984 6.54766 17.941 5.64084 16.5842C4.73402 15.2273 4.25 13.632 4.25 12C4.25 10.368 4.73402 8.7727 5.64084 7.41585C6.54766 6.059 7.83653 5.00158 9.34442 4.37735C10.8523 3.75313 12.5114 3.59014 14.112 3.90902C15.7125 4.22789 17.1825 5.0143 18.336 6.16875L21.5235 9.34688",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpdate);
export default __webpack_public_path__ + "static/media/iconUpdate.04880624b5b66d84667f444aa6784e57.svg";
export { ForwardRef as ReactComponent };